import styled from "styled-components/macro";
import Typography from "../../atoms/typography";
import OurMission from "./ourMission";
import media from "../../constants/MediaQuery";
import Theme from "../../constants/Theme";

const AboutUsHero = () => {
  return (
    <AUStyling>
      <div className="AboutUsHero__AUStyling__au container">
        <div className="AboutUsHero__AUStyling__au--mma">
          <Typography.Heading
            className="landing--text-summary"
            color="pending"
            weight="medium"
            level={3}
            uppercase
            fontType="Galano"
          >
            Our purpose
          </Typography.Heading>
          <Typography.Heading
            className="landing__heading"
            color="darkBlue"
            fontType="Galano"
            weight="medium"
            level={1}
          >
            Money made accessible
          </Typography.Heading>
          <Typography.Text
            level="xlarge"
            color="black"
            weight="medium"
            fontType="Galano"
          >
            The most part of commerce and our personal lives revolve around
            moving money to different places for different reasons. DotPay along
            with our team of Agents exist solely to make such transactions fast,
            secure and convenient.
          </Typography.Text>
        </div>
        <OurMission />
      </div>
    </AUStyling>
  );
};
const AUStyling = styled.section`
  position: relative;
  background: ${Theme.colorPalette.landingBackground};
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  ${media.smallDesktopMin` 
  justify-content: center;
  align-items: center;   
  flex-direction: row;`}
  .AboutUsHero__AUStyling {
    &__au {
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      &--mma {
        max-width: 800px;
        text-align: center;
      }
    }
  }
`;

export default AboutUsHero;
